<main class="ndp-page-container container-md">
  <ng-content></ng-content>
</main>
